export * from './alert.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_directives/index.ts